<template>
  <div class="baseForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :rules="baseDataRules"
      @input="handleChangeBaseData"
      label-width="105px"
      :disabled="!canEdit"
    ></base-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchTable from '@/components/form-item/search-table';
  // import API from '@/api/capitalCenter/settle';
  // import GOODS_API from '@/api/masterData/goods';
  import DataBaseAPI from '@/api/dataBase';
  // import InputNumber from '@/components/form-item/input-number';
  import { dateFormatter } from '@/common/js/util';
  import BaseForm from '@/components/form/base-form';

  export default {
    name: 'slipBaseForm',
    components: {
      // SearchTable,
      // InputNumber,
      BaseForm,
    },
    props: ['canEdit'],
    created() {
      if (this.$route.name.indexOf('Add') != -1) {
        this.baseData.slipCompanyNo = this.userInfo.companyCode;
        this.baseData.slipCompanyName = this.userInfo.companyName;
        this.getDepartment(this.baseData.slipCompanyNo); // 部门
        this.baseData.slipDepartmentNo = this.userInfo.departmentCode;
        this.baseData.slipDepartmentName = this.userInfo.departmentName;
        this.baseData.slipCreatePersonNo = this.userInfo.userCode;
        this.baseData.slipCreatePersonName = this.userInfo.userName;
      }
      this.getCompany();
    },
    data() {
      return {
        baseData: {
          id: null,
          slipNo: null,
          slipDesc: null,
          orderNo: null,
          slipCompanyNo: null,
          slipCompanyName: null,
          slipDepartmentNo: null,
          slipDepartmentName: null,
          slipDate: dateFormatter(new Date()),
          supplierNo: null,
          supplierName: null,
          settleNo: null,
          settleDesc: null,
          productNo: null,
          productDesc: null,
          settleQuantity: null,
          slipCreatePersonNo: null,
          slipCreatePersonName: null,
          slipStatus: null,
          slipStatusName: null,
          mark: null,
        },
        companyList: [], //公司代码下拉数据
        departmentList: [], //部门下拉数据
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      baseDataRules() {
        return {
          settleNo: [
            {
              required: true,
              message: this.$t('statementsAdd.baseForm.settleNoPlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
          slipDesc: [
            {
              required: true,
              message: this.$t('statementsAdd.baseForm.slipDescPlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
          slipDate: [
            {
              required: true,
              message: this.$t('statementsAdd.baseForm.slipDatePlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
          slipCreatePersonName: [
            {
              required: true,
              message: this.$t('statementsAdd.baseForm.slipCreatePersonNamePlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 结算单号
            type: 'input',
            label: this.$t('statementsAdd.baseForm.slipNo'),
            prop: 'slipNo',
            placeholder: this.$t('statementsAdd.baseForm.slipNoPlaceholder'),
            disabled: true,
          },
          {
            // 结算单描述
            type: 'input',
            label: this.$t('statementsAdd.baseForm.slipDesc'),
            prop: 'slipDesc',
            required: true,
          },
          {
            // 公司
            type: 'select',
            label: this.$t('statementsAdd.baseForm.slipCompanyNo'),
            prop: 'slipCompanyNo',
            options: this.companyList,
            filterable: true,
            required: true,
          },
          {
            // 部门
            type: 'select',
            label: this.$t('statementsAdd.baseForm.slipDepartmentNo'),
            prop: 'slipDepartmentNo',
            options: this.departmentList,
            filterable: true,
            required: true,
          },
          {
            // 结算日期
            type: 'date',
            label: this.$t('statementsAdd.baseForm.slipDate'),
            prop: 'slipDate',
            required: true,
          },
          {
            // 结算批次编号
            type: 'searchTable',
            prop: 'settleNo',
            searchType: 'settle',
            isMultiple: true,
            label: this.$t('statementsAdd.baseForm.settleNo'),
            required: true,
            currentValue: this.baseData.settleNo,
          },
          {
            // 结算批次描述
            type: 'input',
            label: this.$t('statementsAdd.baseForm.settleDesc'),
            prop: 'settleDesc',
            disabled: true,
          },
          {
            // 业务订单号
            type: 'input',
            label: this.$t('statementsAdd.baseForm.orderNo'),
            prop: 'orderNo',
            disabled: true,
          },
          {
            // 供应链主体
            type: 'input',
            label: this.$t('statementsAdd.baseForm.supplierName'),
            prop: 'supplierName',
            disabled: true,
          },
          {
            // 商品
            type: 'input',
            label: this.$t('statementsAdd.baseForm.productDesc'),
            prop: 'productNo',
            disabled: true,
          },
          {
            // 结算数量
            type: 'amountNumber',
            label: this.$t('statementsAdd.baseForm.settleQuantity'),
            prop: 'settleQuantity',
            required: true,
            precision: this.$globalVar.qPoint,
            max: 999999999.999,
            min: 0,
          },
          {
            // 创建人
            type: 'searchTable',
            prop: 'slipCreatePersonName',
            searchType: 'personnel',
            isMultiple: true,
            label: this.$t('statementsAdd.baseForm.slipCreatePersonName'),
            required: true,
            currentValue: this.baseData.slipCreatePersonName,
          },
          {
            // 结算单状态
            type: 'dict',
            dictType: 'slip_status',
            label: this.$t('statementsAdd.baseForm.slipStatus'),
            prop: 'slipStatus',
            required: true,
          },
          {
            // 备注
            type: 'textarea',
            label: this.$t('statementsAdd.baseForm.mark'),
            prop: 'mark',
            span: 20,
            maxlength: 200,
          },
        ];
      },
    },
    methods: {
      getDetail(allDetail) {
        Object.keys(this.baseData).map((item) => {
          return (this.baseData[item] = allDetail[item]);
        });
        this.getDepartment(this.baseData.slipCompanyNo);
      },
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'settleNo') {
          // 业务订单
          this.searchTableChange(value.settleNo, [
            { val: 'settleNo' },
            { val: 'settleDesc' },
            { val: 'supplierNo' },
            { val: 'supplierName' },
            { val: 'productNo' },
            { val: 'productDesc' },
            { val: 'settleQuantity', getVal: 'deliveryQuantity' },
            { val: 'orderNo' },
            { val: 'settleType' },
          ]);
        }
        if (prop == 'slipCompanyNo') {
          // 公司
          this.companyChange(value.slipCompanyNo);
        }
        if (prop == 'slipCreatePersonName') {
          this.searchTableChange(value.slipCreatePersonName, [
            { val: 'slipCreatePersonNo', getVal: 'id' },
            { val: 'slipCreatePersonName', getVal: 'personName' },
          ]);
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门 获取部门数据
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (this.departmentList.length == 0) {
              this.$message({
                showClose: true,
                message: this.$t('statementsAdd.msg.noDepartment'),
                type: 'error',
              });
            }
          }
        } else {
          this.departmentList = [];
        }
      },
      companyChange(val) {
        // 公司
        this.baseData.slipCompanyName = val
          ? this.companyList.find((item) => item.value == val).label
          : null;
        this.baseData.slipDepartmentNo = this.baseData.slipDepartmentName = null;
        this.getDepartment(val);
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.baseData[item.val] = val[0][item.getVal];
            } else {
              this.baseData[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.baseData[item.val] = null;
          });
        }
      },
      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
